<template>
  <b-modal :id="id" title="Detalle de qc" :header-bg-variant="data ? getBootstrapColorName(data.color) : ''">
    <div v-if="Object.keys(data).length === 0">Nada que mostrar</div>
    <div v-else>
      <ul v-for="(qc, index) in Object.keys(data.data)" :key="index">
        <li>
          <strong>{{ qc }}:</strong> {{ data.data[qc] }}
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
import { getBootstrapColorName } from "../../../../utils";
export default {
  name: "ModalQc",
  methods: {
    getBootstrapColorName
  },
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
